




































import { Component, Inject, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { getModule } from "vuex-module-decorators";

import SubmitButton from "@/lib/components/SubmitButton.vue";
import FormErrors from "@/lib/components/FormErrors.vue";

import GeneralFormMixin from "@/lib/mixins/GeneralForm";
import dataStore from "@/store";
import { DIContainer } from "@/app.container";
import IdGenerator from "@/lib/services/id-generator";
import UpgradeLabelResolverService from "@/modules/plushie/upgrade-label-resolver.service";

import PlushieStore from "../../store";
import Upgrade from "../../upgrade.model";
import PlushieUpgradeRelation from "../../plushie-upgrade-relation.model";

@Component({
  components: {
    SubmitButton,
    FormErrors,
  },
})
export default class PlushieUpgradeAddForm extends mixins(GeneralFormMixin) {
  @Prop({ required: true })
  public readonly plushieId!: string;

  @Inject("IdGenerator")
  private fIdGenerator!: IdGenerator;

  @Inject("UpgradeLabelResolverService")
  private fUpgradeLabelResolver!: UpgradeLabelResolverService;

  private fPlushieStore: PlushieStore;
  private fIsLoading = true;
  private fSelectedUpgradeId = "";

  get availableUpgrades(): Upgrade[] {
    const allUpgrades = this.fPlushieStore.upgradesList;
    const selectedUpgradeIds = this.fPlushieStore.getPlushieUpgradesByPlushieId(
      this.plushieId
    );

    return allUpgrades.filter(
      (upgrade) =>
        upgrade.isManualAssignmentAllowed &&
        !selectedUpgradeIds.includes(upgrade.id)
    );
  }

  get isLoading(): boolean {
    return this.fIsLoading;
  }

  get selectedUpgradeId(): string {
    return this.fSelectedUpgradeId;
  }

  set selectedUpgradeId(value: string) {
    this.fSelectedUpgradeId = value;
  }

  get showForm(): boolean {
    return !this.isLoading && this.availableUpgrades.length > 0;
  }

  constructor() {
    super();
    this.fPlushieStore = getModule(PlushieStore, dataStore);
  }

  public getUpgradeLabel(upgrade: Upgrade): string {
    return this.fUpgradeLabelResolver.resolve(upgrade);
  }

  created(): void {
    void this.loadData();
  }

  protected async performSubmit(): Promise<void> {
    if (!this.selectedUpgradeId) {
      return;
    }

    const relationId = this.fIdGenerator.getId();
    const relation = new PlushieUpgradeRelation(
      relationId,
      this.plushieId,
      this.selectedUpgradeId
    );
    await DIContainer.PlushieUpgradeRelationRepository.save(relation);

    await this.fPlushieStore.loadPlushieUpgradesByPlushieId({
      plushieId: this.plushieId,
      useCache: false,
      isDisablePagination: true,
    });

    this.fSelectedUpgradeId = "";
  }

  private async loadData(): Promise<void> {
    this.fIsLoading = true;

    try {
      await Promise.all([
        this.fPlushieStore.loadUpgrades(),
        this.fPlushieStore.loadPlushieUpgradesByPlushieId({
          plushieId: this.plushieId,
          isDisablePagination: true,
        }),
      ]);
    } finally {
      this.fIsLoading = false;
    }
  }
}
